
export const parseBrokerPayload = (data: any) => {
    return {
      _id: data?._id ?? null,
      companyName: data?.company_name ?? null,   // If you want both fields
      company_name: data?.company_name ?? null,
  
      first_name: data?.first_name ?? null,
      last_name: data?.last_name ?? null,
      iso_code: data?.iso_code ?? null,
      zip_code: data?.zip_code ?? null,
  
      mc_number: data?.mc_number ?? null,
      dot_number: data?.dot_number ?? null,
      physical_address: data?.physical_address ?? null,
  
      isAssigned: data?.isAssigned ?? false,
      instruction: data?.instruction ?? null,
  
      contact_information: Array.isArray(data?.contact_information)
        ? data.contact_information.map((c: any) => ({
            phone_number: c?.phone_number ?? null,
            email: c?.email ?? null,
          }))
        : [],
  
      website_url: data?.website_url ?? null,
  
      isDeleted: data?.isDeleted ?? false,
      isBlocked: data?.isBlocked ?? false,
  
      carrierSetup: data?.carrierSetup ?? null,
      loadBoard: data?.loadBoard ?? null,
  
      // Social links
      linkedin: data?.linkedin ?? null,
      facebook: data?.facebook ?? null,
      instagram: data?.instagram ?? null,
      xcom: data?.xcom ?? null,
  
      showOnTop: data?.showOnTop ?? false,
      priority: data?.priority ?? 9999,
    };
  };